import cartAPI from 'apis/cart';

import type { ExpandedCartProduct } from 'domains/cart_products';

export const find = async (id: number) => {
  const { data } = await cartAPI.get<ExpandedCartProduct>(`/products/${id}`);
  return data;
};
